<template>
    <div
        id="toast-container-component"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 11">
        <div
            id="toast-template"
            class="toast align-items-center text-white border-0 hide"
            role="alert"
            aria-live="assertive"
            aria-atomic="true">
            <div class="toast-body">
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { Watch } from 'vue-property-decorator'

import { useCommonStore } from "@/stores/common";

import { TEXT_KEYS } from "@/constants";

@Options({
  components: {
  }
})
export default class ToastContainer extends Vue {
  commonStore = useCommonStore()

  TEXT_KEYS = TEXT_KEYS

  get toastMessage() {
    return this.commonStore.getToastMessage
  }

  @Watch('toastMessage')
  onToastMessageChanged(val: Record<string, string>, oldVal: Record<string, string>) {
    console.log("onToastMessageChanged", val, oldVal)

    if (val) {
        const toastTemplateElement: HTMLElement | null = document.getElementById("toast-template")

        if (toastTemplateElement) {
            const newToastElement: HTMLElement = toastTemplateElement.cloneNode(true) as HTMLElement

            const newElementId = `toast-element-${(new Date()).getTime()}`
            newToastElement.id = newElementId

            if (val.type === "success") {
                newToastElement.classList.add("bg-success");
            } else if (val.type === "danger") {
                newToastElement.classList.add("bg-danger");
            } else if (val.type === "warning") {
                newToastElement.classList.add("bg-warning");
            }

            const newToastBody: HTMLDivElement = newToastElement.firstChild as HTMLDivElement
            newToastBody.textContent = val.message

            const toastContainerElement: HTMLElement | null = document.getElementById("toast-container-component")
            if (toastContainerElement) {
                toastContainerElement.appendChild(newToastElement)

                const addedElt = document.getElementById(newElementId)
                console.log("onToastMessageChanged ADD Checl Can Find Element: ", addedElt)
            }

            newToastElement.addEventListener('hidden.bs.toast', () => {
                const toastContainerElement: HTMLElement | null = document.getElementById("toast-container-component")
                if (toastContainerElement) {
                    const lastChildNode: Node | null = toastContainerElement.lastChild

                    if (lastChildNode) {
                        toastContainerElement.removeChild(lastChildNode)
                    }
                }
            })

            this.showToast(`#${newElementId}`)
        }
    }
  }

  private showToast(id: string) {
    console.log("showToast", id)

    const toastElement: Element | null = document.querySelector(id)

    if (toastElement && window) {
        const toast = new window.bootstrap.Toast(toastElement, {
            animation: true,
            autohide: true,
            delay: 2000,
        })

        toast.show()
    }
  }
}
</script>

<style lang="stylus">
</style>
